import axios from "axios";
import type { Category } from "./types";

export interface CategoriesResponse {
    data: Category[];
}

const isLocal = window.location.origin.includes("localhost");
const API_BASE = isLocal
    ? "/api"
    : "https://api.centralcart.com.br/v1/webstore";


export const getCategories = async (limit = 1000): Promise<CategoriesResponse> => {
    const { data } = await axios.get<CategoriesResponse>(
        `${API_BASE}/category?limit=${limit}`,
        {
            headers: {
                "x-store-domain": "howstore.gg",
                "Content-Type": "application/json",
            },
        }
    );
    return data;
};
